export interface CustomTheme {
  name: string;
  id: string;
  primitive: {
    [key: string]: string;
  };
  primitive_dark: {
    [key: string]: string;
  };
}

export const CUSTOM_THEMES: CustomTheme[] = [
  {
    name: 'Octet Design',
    id: 'octet-design',
    primitive: {
      '50': '#FEFEFE', // Main background (very light)
      '100': '#F4F4F4', // Secondary background
      '200': '#DFDFE2', // Border, divider, subtle backgrounds
      '300': '#BEC0BF', // Muted elements, disabled backgrounds
      '400': '#708A83', // Accent, icons (inactive), secondary buttons
      '500': '#476E66', // Primary accent, icons (active), primary buttons
      '600': '#3c5d58', // Text (secondary), icons (hover)
      '700': '#314b45', // Text (primary), strong icons
      '800': '#263935', // Headings, strong text
      '900': '#1b2825', // Very dark elements, overlays
      '950': '#101615', // Almost black, modal backgrounds
    },
    primitive_dark: {
      '50': '#101615', // Main background (very dark)
      '100': '#1b2825', // Secondary background
      '200': '#263935', // Border, divider, subtle backgrounds
      '300': '#314b45', // Muted elements, disabled backgrounds
      '400': '#3c5d58', // Accent, icons (inactive), secondary buttons
      '500': '#476E66', // Primary accent, icons (active), primary buttons
      '600': '#708A83', // Text (secondary), icons (hover)
      '700': '#BEC0BF', // Text (primary), strong icons
      '800': '#DFDFE2', // Headings, strong text
      '900': '#F4F4F4', // Very light elements, overlays
      '950': '#FEFEFE', // Almost white, modal backgrounds
    },
  },
  {
    name: 'Calm Green',
    id: 'calm-green',
    primitive: {
      '50': '#FEFEFE', // Main background (very light)
      '100': '#F4F4F4', // Secondary background
      '200': '#DFDFE2', // Border, divider, subtle backgrounds
      '300': '#BEC0BF', // Muted elements, disabled backgrounds
      '400': '#8DA19C', // Accent, icons (inactive), secondary buttons
      '500': '#708A83', // Primary accent, icons (active), primary buttons
      '600': '#5A6E69', // Text (secondary), icons (hover)
      '700': '#476E66', // Text (primary), strong icons
      '800': '#395851', // Headings, strong text
      '900': '#2A423D', // Very dark elements, overlays
      '950': '#233733', // Almost black, modal backgrounds
    },
    primitive_dark: {
      '50': '#233733', // Main background (very dark)
      '100': '#2A423D', // Secondary background
      '200': '#395851', // Border, divider, subtle backgrounds
      '300': '#476E66', // Muted elements, disabled backgrounds
      '400': '#5A6E69', // Accent, icons (inactive), secondary buttons
      '500': '#708A83', // Primary accent, icons (active), primary buttons
      '600': '#8DA19C', // Text (secondary), icons (hover)
      '700': '#BEC0BF', // Text (primary), strong icons
      '800': '#DFDFE2', // Headings, strong text
      '900': '#F4F4F4', // Very light elements, overlays
      '950': '#FEFEFE', // Almost white, modal backgrounds
    },
  },
  {
    name: 'White Duck',
    id: 'white-duck',
    primitive: {
      '50': '#FEFEFE', // Main background (very light)
      '100': '#F4F4F4', // Secondary background
      '200': '#DFDFE2', // Border, divider, subtle backgrounds
      '300': '#cecece', // Light gray, borders, disabled backgrounds
      '400': '#000000', // Secondary accent (orange)
      '500': '#000000', // Primary accent (black)
      '600': '#000000', // Secondary accent (orange)
      '700': '#000000', // Primary text/icons (black)
      '800': '#000000', // Headings, strong text (black)
      '900': '#000000', // Secondary accent (orange)
      '950': '#2f2000', // Very dark brown, overlays, special accents
    },
    primitive_dark: {
      '50': '#262626', // Main background (very dark)
      '100': '#333333', // Secondary background
      '200': '#545454', // Border, divider, subtle backgrounds
      '300': '#cecece', // Light gray, borders, disabled backgrounds
      '400': '#ff9900', // Secondary accent (orange)
      '500': '#000000', // Primary accent (black)
      '600': '#ff9900', // Secondary accent (orange)
      '700': '#f5f5f5', // Primary text/icons (white)
      '800': '#fafafa', // Headings, strong text (white)
      '900': '#ff9900', // Secondary accent (orange)
      '950': '#2f2000', // Very dark brown, overlays, special accents
    },
  },
];
